/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import React from 'react';
import DatePickerHeader from '../base/Header.js';
import DatePickerTable from '../base/Table.js';
import { TimePickerPanel } from '../../time-picker/index.js';
import useConfig from '../../hooks/useConfig.js';
import { getDefaultFormat } from '../../_common/js/date-picker/format.js';
import '../../_chunks/dep-fd3498b6.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../locale/LocalReceiver.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../config-provider/ConfigContext.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../select/index.js';
import '../../select/base/Select.js';
import '../../_chunks/dep-92728dc5.js';
import 'classnames';
import '../../_chunks/dep-337b4140.js';
import '../../_chunks/dep-ca64038e.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-33ffecad.js';
import '../../hooks/useControlled.js';
import '../../_chunks/dep-f721d103.js';
import '../../_chunks/dep-4559db64.js';
import '../../_chunks/dep-c00532d4.js';
import '../../_util/noop.js';
import '../../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../../select/util/helper.js';
import '../../select/base/OptionGroup.js';
import '../../select/defaultProps.js';
import '../../select/base/Option.js';
import '../../_chunks/dep-0e15088f.js';
import '../../_chunks/dep-6c5254c6.js';
import '../../hooks/useDomRefCallback.js';
import '../../_util/useRipple.js';
import '../../_util/useAnimation.js';
import '../../_util/setStyle.js';
import '../../_util/dom.js';
import 'raf';
import '../../_util/easing.js';
import '../../common/FakeArrow.js';
import '../../loading/index.js';
import '../../loading/Loading.js';
import '../../common/Portal.js';
import 'react-dom';
import '../../loading/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '../../_chunks/dep-ec16db36.js';
import '../../_chunks/dep-036ad2cc.js';
import '../../loading/defaultProps.js';
import '../../loading/plugin.js';
import '../../_util/react-render.js';
import '../../_chunks/dep-e0370ebe.js';
import '../../loading/style/css.js';
import '../../loading/type.js';
import '../../select-input/index.js';
import '../../select-input/SelectInput.js';
import '../../popup/index.js';
import '../../popup/Popup.js';
import 'react-transition-group';
import 'react-popper';
import '../../hooks/usePrevious.js';
import '../../popup/hooks/useTrigger.js';
import 'react-is';
import '../../popup/utils/ref.js';
import '../../_util/composeRefs.js';
import '../../popup/utils/transition.js';
import '../../_util/useMutationObserver.js';
import '../../_chunks/dep-01ce608f.js';
import '../../_chunks/dep-77a54538.js';
import '../../_util/useWindowSize.js';
import '../../popup/defaultProps.js';
import '../../popup/style/css.js';
import '../../popup/type.js';
import '../../select-input/useSingle.js';
import '../../_chunks/dep-4f1e1217.js';
import '../../_chunks/dep-29cb89ad.js';
import '../../_chunks/dep-e73d1b75.js';
import '../../_chunks/dep-c8399d32.js';
import '../../input/index.js';
import '../../input/Input.js';
import 'tdesign-icons-react';
import '../../_util/useLayoutEffect.js';
import '../../hooks/useGlobalIcon.js';
import '../../input/InputGroup.js';
import '../../input/defaultProps.js';
import '../../_util/parseTNode.js';
import '../../input/useLengthLimit.js';
import '../../_common/js/log/index.js';
import '../../_common/js/log/log.js';
import '../../input/style/css.js';
import '../../input/type.js';
import '../../select-input/useMultiple.js';
import '../../tag-input/index.js';
import '../../tag-input/TagInput.js';
import '../../_util/useDragSorter.js';
import '../../tag-input/useTagScroll.js';
import '../../tag-input/useTagList.js';
import '../../tag/index.js';
import '../../tag/Tag.js';
import '../../tag/CheckTag.js';
import '../../tag/defaultProps.js';
import '../../tag/style/css.js';
import '../../tag/type.js';
import '../../tag-input/useHover.js';
import '../../tag-input/defaultProps.js';
import '../../tag-input/style/css.js';
import '../../tag-input/type.js';
import '../../select-input/useOverlayInnerStyle.js';
import '../../select-input/defaultProps.js';
import '../../select-input/style/css.js';
import '../../select-input/type.js';
import '../../select/base/PopupContent.js';
import '../../select/hooks/usePanelVirtualScroll.js';
import '../../hooks/useVirtualScroll.js';
import '../../hooks/useResizeObserver.js';
import '../../select/hooks/useOptions.js';
import '../../select/style/css.js';
import '../../select/type.js';
import '../../pagination/index.js';
import '../../pagination/Pagination.js';
import '../../_chunks/dep-7b67cdbf.js';
import '../../_chunks/dep-09050977.js';
import '../../_chunks/dep-23d0a0bb.js';
import '../../input-number/index.js';
import '../../input-number/InputNumber.js';
import '../../button/index.js';
import '../../button/Button.js';
import '../../button/defaultProps.js';
import '../../button/style/css.js';
import '../../button/type.js';
import '../../input-number/useInputNumber.js';
import '../../_util/useCommonClassName.js';
import '../../_common/js/input-number/number.js';
import '../../_chunks/dep-a827ffec.js';
import '../../_common/js/input-number/large-number.js';
import '../../input-number/defaultProps.js';
import '../../input-number/style/css.js';
import '../../input-number/type.js';
import '../../input-adornment/index.js';
import '../../input-adornment/InputAdornment.js';
import '../../input-adornment/style/css.js';
import '../../input-adornment/type.js';
import '../../pagination/hooks/useBoundaryJumper.js';
import '../../pagination/hooks/usePrevNextJumper.js';
import '../../pagination/hooks/usePageNumber.js';
import '../../pagination/hooks/useTotal.js';
import '../../pagination/validators.js';
import '../../pagination/defaultProps.js';
import '../../pagination/PaginationMini.js';
import '../../pagination/style/css.js';
import '../../pagination/type.js';
import '../base/Cell.js';
import '../../_common/js/date-picker/utils.js';
import '../../_chunks/dep-fdce1f4f.js';
import '../../time-picker/TimePicker.js';
import '../../time-picker/TimeRangePicker.js';
import '../../range-input/index.js';
import '../../range-input/RangeInput.js';
import '../../range-input/defaultProps.js';
import '../../range-input/RangeInputPopup.js';
import '../../range-input/style/css.js';
import '../../range-input/type.js';
import '../../time-picker/panel/TimePickerPanel.js';
import '../../time-picker/panel/SinglePanel.js';
import '../../time-picker/hooks/useTimePickerTextConfig.js';
import '../../_common/js/time-picker/const.js';
import '../../_common/js/time-picker/utils.js';
import '../../hooks/useDebounce.js';
import '../../_util/usePersistFn.js';
import '../../hooks/usePropsRef.js';
import '../../time-picker/defaultProps.js';
import '../../time-picker/style/css.js';
import '../../time-picker/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function PanelContent(props) {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var panelName = "".concat(classPrefix, "-date-picker__panel");
  var value = props.value,
    year = props.year,
    month = props.month,
    mode = props.mode,
    format = props.format,
    enableTimePicker = props.enableTimePicker,
    timePickerProps = props.timePickerProps,
    firstDayOfWeek = props.firstDayOfWeek,
    _props$partial = props.partial,
    partial = _props$partial === void 0 ? "start" : _props$partial,
    time = props.time,
    tableData = props.tableData,
    _onMonthChange = props.onMonthChange,
    _onYearChange = props.onYearChange,
    _onJumperClick = props.onJumperClick,
    _onCellClick = props.onCellClick,
    _onCellMouseEnter = props.onCellMouseEnter,
    onCellMouseLeave = props.onCellMouseLeave,
    onTimePickerChange = props.onTimePickerChange;
  var _getDefaultFormat = getDefaultFormat({
      mode: mode,
      format: format,
      enableTimePicker: enableTimePicker
    }),
    timeFormat = _getDefaultFormat.timeFormat;
  var showTimePicker = enableTimePicker && mode === "date";
  var defaultTime = "00:00:00";
  return /* @__PURE__ */React.createElement("div", {
    className: "".concat(panelName, "-content")
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(panelName, "-").concat(mode)
  }, /* @__PURE__ */React.createElement(DatePickerHeader, {
    mode: mode,
    year: year,
    month: month,
    onMonthChange: function onMonthChange(val) {
      return _onMonthChange === null || _onMonthChange === void 0 ? void 0 : _onMonthChange(val, {
        partial: partial
      });
    },
    onYearChange: function onYearChange(val) {
      return _onYearChange === null || _onYearChange === void 0 ? void 0 : _onYearChange(val, {
        partial: partial
      });
    },
    onJumperClick: function onJumperClick(_ref) {
      var trigger = _ref.trigger;
      return _onJumperClick === null || _onJumperClick === void 0 ? void 0 : _onJumperClick({
        trigger: trigger,
        partial: partial
      });
    }
  }), /* @__PURE__ */React.createElement(DatePickerTable, {
    mode: mode,
    data: tableData,
    value: value,
    time: time,
    format: format,
    firstDayOfWeek: firstDayOfWeek,
    onCellClick: function onCellClick(date, _ref2) {
      var e = _ref2.e;
      return _onCellClick === null || _onCellClick === void 0 ? void 0 : _onCellClick(date, {
        e: e,
        partial: partial
      });
    },
    onCellMouseEnter: function onCellMouseEnter(date) {
      return _onCellMouseEnter === null || _onCellMouseEnter === void 0 ? void 0 : _onCellMouseEnter(date, {
        partial: partial
      });
    },
    onCellMouseLeave: onCellMouseLeave
  })), showTimePicker && /* @__PURE__ */React.createElement("div", {
    className: "".concat(panelName, "-time")
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(panelName, "-time-viewer")
  }, time || defaultTime), /* @__PURE__ */React.createElement(TimePickerPanel, _objectSpread({
    key: partial,
    format: timeFormat,
    value: time || defaultTime,
    onChange: onTimePickerChange,
    isShowPanel: props.popupVisible
  }, timePickerProps))));
}

export { PanelContent as default };
//# sourceMappingURL=PanelContent.js.map
